<template>
  <div class="index">
    <header>
      <div class="w">
        <a href="javascript:;" @click="toTop('heads')" class="fl">
          <img src="static/img/logo.png" alt="" />

          <span>{{ language.v_index_PocketCash }}</span>
        </a>

        <div class="fr">
          <a href="javascript:;" @click="toTop('heads')">
            {{ language.v_index_homepage }}
          </a>

          <a href="javascript:;" @click="toTop('Productintro')">
            {{ language.v_index_Product_introduction }}
          </a>

          <a href="javascript:;" @click="toTop('About_us')">
            {{ language.v_index_About_us }}
          </a>

          <!-- <a href="javascript:;" class="QRcode">
            {{language.v_index_download}}
            <div class="QRcodecon">
              <img src="static/img/QRcode.png" alt="">
              <p>{{language.v_index_downloaddetails}}</p>
            </div>
          </a> -->

          <button @click="changelang">
            <img src="static/img/changelang.png" alt="" />
            {{ language.type == "en_US" ? "Filipino" : "English" }}
          </button>
        </div>
      </div>
    </header>

    <!-- <div class="QRcodecon">

      <img src="static/img/QRcode.png" alt="" />

      <p>{{language.v_index_downloaddetails}}</p>

    </div> -->

    <div class="con" id="heads">
      <div class="con0">
        <img src="static/img/banner.png" alt="" />

        <p class="tit">
          <img src="static/img/con_logo.png" alt="" />

          <span>{{ language.v_index_PocketCash }}</span>
        </p>

        <p class="detail1">{{ language.v_index_con0_detail1 }}</p>

        <p class="detail2">{{ language.v_index_con0_detail2 }}</p>
      </div>

      <div class="w con1">
        <div>
          <img :src="'static/img/con1_withdrawal.png'" alt="" />

          <p>{{ language.v_index_con1_tit1 }}</p>

          <span>{{ language.v_index_con1_txt1 }}</span>
        </div>

        <div>
          <img :src="'static/img/con1_appaply.png'" alt="" />

          <p>{{ language.v_index_con1_tit2 }}</p>

          <span>{{ language.v_index_con1_txt2 }}</span>
        </div>

        <div>
          <img :src="'static/img/con1_preferential.png'" alt="" />

          <p>{{ language.v_index_con1_tit3 }}</p>

          <span>{{ language.v_index_con1_txt3 }}</span>
        </div>
      </div>

      <div class="con2" id="Productintro">
        <div class="w">
          <p>{{ language.v_index_con2_tit }}</p>

          <span>{{ language.v_index_con2_titdetail }}</span>

          <div class="con2list">
            <div>
              <img src="static/img/con2_login.png" alt="" />

              <p>{{ language.v_index_con2_con1 }}</p>

              <img class="step" src="static/img/step1.png" alt="" />

              <div class="line">
                <i></i>
              </div>
            </div>

            <div>
              <img src="static/img/con2_setname.png" alt="" />

              <p>{{ language.v_index_con2_con21 }}</p>

              <p>{{ language.v_index_con2_con22 }}</p>

              <img class="step" src="static/img/step2.png" alt="" />

              <div class="line">
                <i></i>

                <span>{{ language.v_index_con2_con4 }}</span>
              </div>
            </div>

            <div>
              <img src="static/img/con2_relpay.png" alt="" />

              <p>{{ language.v_index_con2_con31 }}</p>

              <p>{{ language.v_index_con2_con32 }}</p>

              <img class="step" src="static/img/step3.png" alt="" />
            </div>
          </div>
        </div>
      </div>

      <div class="con3">
        <div>
          <div class="w clearfix" style="overflow: hidden">
            <div class="fl">
              <div class="txtcon">
                <p class="tit">{{ language.v_index_con3_tit1 }}</p>

                <p class="con">{{ language.v_index_con3_con11 }}</p>

                <p class="con">{{ language.v_index_con3_con12 }}</p>
              </div>
            </div>

            <div class="fr">
              <img
                style="position: relative; top: 16px"
                src="static/img/con3_personalinfor.png"
                alt=""
              />
            </div>
          </div>
        </div>

        <div>
          <div class="w clearfix">
            <div class="fl">
              <img src="static/img/con3_riskcontrol.png" alt="" />
            </div>

            <div class="fr">
              <div class="txtcon">
                <p class="tit">{{ language.v_index_con3_tit2 }}</p>

                <p class="con">{{ language.v_index_con3_con21 }}</p>
              </div>
            </div>
          </div>
        </div>

        <div>
          <div class="w clearfix">
            <div class="fl">
              <div class="txtcon">
                <p class="tit">{{ language.v_index_con3_tit3 }}</p>

                <p class="con">{{ language.v_index_con3_con31 }}</p>

                <p class="con">{{ language.v_index_con3_con32 }}</p>

                <p class="con">{{ language.v_index_con3_con33 }}</p>
              </div>
            </div>

            <div class="fr">
              <img src="static/img/con3_financialservice.png" alt="" />
            </div>
          </div>
        </div>

        <div>
          <div class="w clearfix" style="overflow: hidden">
            <div class="fl">
              <img
                style="position: relative; top: 17px"
                src="static/img/con3_relpay.png"
                alt=""
              />
            </div>

            <div class="fr">
              <div class="txtcon">
                <p class="tit">{{ language.v_index_con3_tit4 }}</p>

                <p class="con">{{ language.v_index_con3_con41 }}</p>

                <p class="con">{{ language.v_index_con3_con42 }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="con4" id="About_us">
        <div class="w">
          <p>{{ language.v_index_con4_tit }}</p>

          <p class="con">{{ language.v_index_con4_con }}</p>
        </div>
      </div>
    </div>

    <footer>
      <div class="w">
        <!-- <a href="javascript:;">{{language.v_index_foot1}}</a> -->

        <a href="javascript:;">{{ language.v_index_foot2 }}</a>
      </div>
    </footer>
  </div>
</template>

<script>
import language from "../language/index.js";
import $ from "jquery";
export default {
  name: "index",
  data() {
    return { language };
  },
  methods: {
    changelang() {
      if (this.language.type == "en_US") {
        window.location.href = window.location.origin + "/#/index?lan=tl_PH";
      } else {
        window.location.href = window.location.origin + "/#/index?lan=en_US";
      }
      window.location.reload();
    },
    toTop(str) {
      $("html, body").animate(
        { scrollTop: $("#" + str + "").offset().top },
        200
      );
    },
  },
};
</script>

<style lang="less">
.index {
  position: relative;
  font-size: 16px;
  > .QRcodecon {
    width: 162px;
    height: 196px;
    position: fixed;
    top: 60%;
    right: 20px;
    z-index: 999;
    > img {
      width: 100%;
      height: 100%;
      // box-shadow: -2px 3px 20px #77578f;
      position: absolute;
      top: 0;
    }
    > p {
      text-align: center;
      color: #5d1690;
      font-size: 12px;
      font-family: Arial;
      line-height: 14px;
      position: absolute;
      padding: 0 15px;
      bottom: 28px;
    }
  }
  header {
    width: 100%;
    height: 60px;
    line-height: 60px;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9;
    background: #5d1690;
    .fl {
      display: inline-block;
      vertical-align: middle;
      height: 44px;
      position: relative;
      font-size: 20px;
      margin-top: 8px;
      img {
        width: 44px;
        height: auto;
        position: absolute;
        top: 0;
      }
      span {
        display: inline-block;
        line-height: 44px;
        position: absolute;
        top: 0;
        left: 62px;
        white-space: nowrap;
      }
    }
    .fr {
      display: inline-block;
      height: 60px;
      > a {
        margin-left: 38px;
        font-size: 14px;
        font-weight: 300;
        display: inline-block;
        height: 100%;
      }
      > a:hover {
        color: #e7ceff;
      }
      > .QRcode {
        position: relative;
        > .QRcodecon {
          width: 162px;
          height: 196px;
          position: absolute;
          top: 42px;
          left: 50%;
          transform: translate(-50%, 0);
          display: none;
          > img {
            width: 100%;
            height: 100%;
            // box-shadow: -2px 3px 20px #77578f;
            position: absolute;
            top: 0;
          }
          > p {
            text-align: center;
            color: #5d1690;
            font-size: 12px;
            font-family: Arial;
            line-height: 14px;
            position: absolute;
            padding: 0 15px;
            bottom: 28px;
          }
        }
      }
      > .QRcode:hover {
        > .QRcodecon {
          display: block;
        }
      }
      > button {
        margin-left: 38px;
        border: 0;
        background: #7f2fca;
        border-radius: 4px;
        color: #ffffff;
        outline: none;
        cursor: pointer;
        font-size: 14px;
        height: 32px;
        padding: 0 9px;
        > img {
          width: 22px;
          vertical-align: middle;
        }
      }
    }
  }
  .con {
    width: 100%;
    .con0 {
      width: 100%;
      height: 730px;
      position: relative;
      text-align: center;
      font-family: Arial;
      font-style: italic;
      > img {
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        z-index: -1;
      }
      .tit {
        padding-top: 200px;
        > img {
          width: 118px;
          height: 118px;
          vertical-align: middle;
          border-radius: 10px;
        }
        span {
          vertical-align: middle;
          font-size: 52px;
          margin-left: 26px;
          font-weight: 600;
        }
      }
      .detail1 {
        font-size: 44px;
        margin-top: 24px;
        font-weight: 600;
        text-shadow: 0 6px 25px rgba(114, 21, 139, 0.4);
      }
      .detail2 {
        font-size: 38px;
        margin-top: 11px;
        text-shadow: 0 6px 8px rgba(135, 59, 204, 0.8);
      }
    }
    .con1 {
      height: 350px;
      display: flex;
      justify-content: space-around;
      > div {
        text-align: center;
        padding: 0 10px;
        > img {
          width: 170px;
          margin-top: 40px;
        }
        > p {
          color: #222222;
          font-size: 17px;
          margin-top: 25px;
        }
        > span {
          color: #999999;
          font-size: 16px;
        }
      }
    }
    .con2 {
      width: 100%;
      height: 540px;
      background-image: radial-gradient(50% 207%, #9844e1 34%, #6527a0 100%);
      .w {
        text-align: center;
        > p,
        > span {
          font-size: 17px;
          font-family: Arial;
          font-style: italic;
          font-weight: 600;
        }
        > p {
          padding-top: 78px;
        }
        .con2list {
          display: flex;
          justify-content: space-around;
          text-align: center;
          margin-top: 43px;
          > div {
            position: relative;
            height: 310px;
            img {
              width: 210px;
              height: 183px;
            }
            p {
              font-size: 16px;
              font-weight: 500;
            }
            .step {
              width: 60px;
              height: 60px;
              position: absolute;
              bottom: 0;
              left: 50%;
              transform: translate(-50%, 0);
            }
            > .line {
              position: absolute;
              top: 105px;
              right: -230px;
              transform: translate(-50%, 0);
              text-align: center;
              font-weight: 500;
              > i {
                display: block;
                width: 135px;
                height: 0;
                border-top: 2px dashed #ffffff;
                margin-bottom: 6px;
              }
            }
          }
        }
      }
    }
    .con3 {
      > div:nth-child(2n) {
        background: #ffffff;
      }
      > div:nth-child(2n + 1) {
        background: #f8f8f8;
      }
      .w {
        height: 310px;
        .fl,
        .fr {
          position: relative;
          .tit {
            color: #222222;
            font-size: 16px;
            margin-bottom: 40px;
            font-family: Arial;
            font-style: italic;
            font-weight: 600;
          }
          .con {
            color: #444444;
            font-size: 14px;
            font-family: Arial;
            font-style: italic;
          }
          > img {
            height: 265px;
            width: auto;
            margin-top: 22px;
          }
          .txtcon {
            padding-top: 110px;
          }
        }
      }
    }
    .con4 {
      height: 270px;
      padding-top: 56px;
      background-image: linear-gradient(-180deg, #ae5fdc 0%, #7631b6 100%);
      p {
        font-size: 16px;
      }
      .con {
        margin-top: 20px;
      }
    }
  }
  footer {
    width: 100%;
    height: 60px;
    line-height: 60px;
    position: absolute;
    bottom: 0;
    left: 0;
    text-align: center;
    background: #5d1690;
    a {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue